<template>
    <v-card color="#F2F2F2" :class="`convention-compact-info-menu`" :elevation="0">
        <v-treeview
            hoverable
            item-key="key"
            expand-icon="mdi-chevron-down"
            :open="open"
            :active="active"
            :items="items"
            activatable
        >
            <template v-slot:label="{ item, open }">
                <table-of-contents-item :ref="item.key" :item="item" :open="open" />
            </template>
        </v-treeview>
    </v-card>
</template>

<script>
import { last, isArray } from "lodash";
import { EventBus } from "src/bus/eventBus";
import scrollManager from "../../managers/scrollManager";
import compactInfoTableOfContentsManager from "../managers/compactInfoTableOfContentsManager";
import TableOfContentsItem from "src/components/common/table-of-contents/TableOfContentsItem.vue";

export default {
    components: { TableOfContentsItem },
    props: ["convention"],
    data() {
        return {
            items: [],
            open: [],
            active: [],
            observers: [],
        };
    },
    mounted() {
        this.items = compactInfoTableOfContentsManager.getAnnotationItems(this.convention);
        EventBus.$on("convention-compact-info-body:scrolled", selectedIds => {
            if (isArray(selectedIds) && selectedIds.length <= 4) {
                this.open = selectedIds;
                const lastId = last(selectedIds);
                this.setActive(lastId);
                this.$nextTick(() => this.checkPosition(lastId));
            }
        });
        setTimeout(() => {
            this.observeTitles(this.items);
        }, 1000);
    },
    watch: {
        convention() {
            this.items = compactInfoTableOfContentsManager.getAnnotationItems(this.convention);
            this.cleanObservers();
            setTimeout(() => {
                this.observeTitles(this.items);
            }, 1000);
        },
    },
    methods: {
        setActive(id) {
            this.active = [id];
        },
        observeTitles(items, pathIds = []) {
            return items.map(item => {
                const titleElement = document.getElementById(item.key);
                if (titleElement !== null) {
                    this.observers.push(
                        scrollManager.observeTitle(titleElement, () => {
                            EventBus.$emit("convention-compact-info-body:scrolled", [
                                ...pathIds,
                                item.key,
                            ]);
                        })
                    );
                }
                if (isArray(item.children) && item.children.length > 0) {
                    this.observeTitles(item.children, [...pathIds, item.key]);
                }
            });
        },
        checkPosition(key) {
            if (this.$refs[key]) {
                const element = this.$refs[key].$el;
                const elementRect = element.getBoundingClientRect();
                const parentRect = this.$el.children[0].getBoundingClientRect();
                const py1 = parentRect.y + 10;
                const py2 = parentRect.y + parentRect.height - 10;
                const y = elementRect.y;
                const isVisible = py1 <= y && py2 >= y;
                if (!isVisible) {
                    const delta = y - py1 - 50;
                    this.$el.children[0].scrollTo(0, this.$el.children[0].scrollTop + delta);
                }
            }
        },
        cleanObservers() {
            this.observers.forEach(observer => observer.disconnect());
            this.observers = [];
        },
    },
};
</script>

<style lang="sass">
.convention-compact-info-menu
    transition: none !important
    position: sticky
    top: 200px
    max-height: calc(100vh - 220px)
    overflow: auto

    .v-treeview > .v-treeview-node
        & > .v-treeview-node__root
            border-bottom: 1px solid transparentize($color-secondary, .5)
        & > .v-treeview-node__children
            border-bottom: 1px solid transparentize($color-secondary, .5)
    .v-treeview > .v-treeview-node--active
        background-color: red
    .legend,
    .empty
        opacity: 0.3
        pointer-events: none
</style>
